import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { DropdownPopper } from '../DropdownPopper/DropdownPopper';

/**
 * A `DropdownPopper` used specifically for `Menu` components.
 *
 * @extends DropdownPopper
 * @since 7.28.0
 */

var MenuPopper = /*#__PURE__*/styled(function (props) {
  return /*#__PURE__*/React.createElement(DropdownPopper, props);
}).withConfig({
  displayName: "MenuPopper",
  componentId: "c11n-8-111-0__sc-mwvf22-0"
})([""]);
MenuPopper.displayName = 'MenuPopper';
MenuPopper.propTypes = {
  /**
   * https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
   */
  'aria-haspopup': PropTypes.oneOf(['menu']),
  /**
   * The `Trigger` `generateLabelledBy` prop.
   */
  'generateLabelledBy': PropTypes.bool,
  /**
   * Will close the Menu when the trigger is no longer visible in the viewport.
   */
  'shouldCloseOnViewportLeave': PropTypes.bool
};
MenuPopper.defaultProps = {
  'aria-haspopup': 'menu',
  'generateLabelledBy': true,
  'shouldCloseOnViewportLeave': false
};

/** @component */
export { MenuPopper };